import apiService from "@common/services/api.service";
import { API } from "@common/services/config";

export default {
  getUserData(token, additionalConfig = {}) {
    const config = {
      params: {
        token
      },
      additionalConfig
    };
    return apiService.user.get(API.USER, config);
  },
  getStartDate() {
    return apiService.user.get(API.START_DATE);
  },
  getLastDate() {
    return apiService.user.get(API.LAST_DATE);
  }
};
